var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.429,
    height: 22.435,
    viewBox: "0 0 22.429 22.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    d: "M25.077,15.714a2.886,2.886,0,0,1,1.852-2.693,11.44,11.44,0,0,0-1.384-3.335,2.925,2.925,0,0,1-1.174.251,2.88,2.88,0,0,1-2.634-4.054A11.406,11.406,0,0,0,18.407,4.5a2.884,2.884,0,0,1-5.385,0A11.44,11.44,0,0,0,9.687,5.884,2.88,2.88,0,0,1,7.052,9.938a2.83,2.83,0,0,1-1.174-.251A11.693,11.693,0,0,0,4.5,13.028a2.885,2.885,0,0,1,.006,5.385A11.44,11.44,0,0,0,5.89,21.748a2.881,2.881,0,0,1,3.8,3.8,11.507,11.507,0,0,0,3.335,1.384,2.878,2.878,0,0,1,5.374,0,11.44,11.44,0,0,0,3.335-1.384,2.884,2.884,0,0,1,3.8-3.8,11.507,11.507,0,0,0,1.384-3.335A2.9,2.9,0,0,1,25.077,15.714Zm-9.31,4.667a4.673,4.673,0,1,1,4.673-4.673A4.671,4.671,0,0,1,15.767,20.381Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#006395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.f835360584756f6ac4d76169b9ad0a24.svg";
export { ForwardRef as ReactComponent };